export const FETCH_SCHEDULES = 'FETCH_SCHEDULES';
export const FETCH_SCHEDULES_DONE = 'FETCH_SCHEDULES_DONE';
export const FETCH_SCHEDULES_ERR = 'FETCH_SCHEDULES_ERR';
export const EDIT_SCHEDULES = 'EDIT_SCHEDULES';
export const EDIT_SCHEDULES_DONE = 'EDIT_SCHEDULES_DONE';
export const EDIT_SCHEDULES_ERR = 'EDIT_SCHEDULES_ERR';
//# sourceMappingURL=actionTypes.js.map